import React from 'react';
import { Popin } from './type';

const View: React.FC<{
  popin: Popin | null;
  closePopin: () => void;
}> = ({}) => {
  return <></>;
};

export default View;
